import * as React from 'react';
const SvgWatch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M12 7.53c3.47 0 6 3.14 6 4.47 0 1.26-2.66 4.47-6 4.47S6 13.26 6 12c0-1.33 2.53-4.47 6-4.47m0-2.03c-4.42 0-8 3.93-8 6.5s3.66 6.5 8 6.5 8-3.99 8-6.5-3.58-6.5-8-6.5"
    />
    <path
      fill="currentColor"
      d="M12 9c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.34-3-3-3"
    />
  </svg>
);
export default SvgWatch;
